module.exports = __webpack_public_path__ + "img/default-bg-vi.3a7cea76.png";